<div class="sale-submissions-popup">
  <form name="saleSubmissionsForm" (ngSubmit)="formSubmit()" [formGroup]="saleSubmissionsForm"
        novalidate>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Sale Submissions Access</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-2">
        <div class="col-2 align-self-center">
          <label for="comments">Comments</label>
        </div>
        <div class="col-10 align-self-center">
          <textarea class="form-control w-100" id="comments" formControlName="comments"></textarea>
          <span class="text-danger" *ngIf="submitted && saleSubmissionsForm.hasError('required', 'comments')">Field is required!</span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-md-12 text-end">
          <button type="submit" class="btn btn-danger">Reject</button>
        </div>
      </div>
    </div>
  </form>
</div>
